import React, { JSX } from 'react'
import moment from 'moment'
export interface DateTimeFieldShowProps {
    kedo: any,
    value?: string,
    deadline?: Array<{
        number: number
        type: string
        color: string
        when: string
    }> | null,
    settings?: any,
    getFormattedDate: (value: string) => string | null
    getColor: (backgroundColor: string, text: string, fontSize?: string) => JSX.Element
}

export const DateTimeFieldShow: React.FC<DateTimeFieldShowProps> = ({
    value,
    deadline,
    kedo,
    settings,
    getFormattedDate,
    getColor,
}) => {
    if (!value) {
        return null
    }

    if (typeof value === 'string' && value == "") {
        return null
    }

    if (
        settings &&
        settings.show_ago === true
    ) {
        moment.locale(kedo.utils().getI18N().language)

        return moment().diff(moment(value as string), 'years')
    }


    if (deadline) {
        const date = getFormattedDate(value as string)
        if (!date) return null

        const targetDate = new Date(date)
        const currentDate = new Date()
        const timeDifference = targetDate.getTime() - currentDate.getTime()
        const daysDifference = Math.ceil(
            timeDifference / (1000 * 3600 * 24)
        )
        const isLeapYear = (year: number) => new Date(year, 1, 29).getMonth() === 1

        for (const items of deadline) {
            const { number, type, color, when } = items
            let daysThreshold = 0
            const year = new Date(
                getFormattedDate(value as string)!
            ).getFullYear()
            const leapYear = isLeapYear(year)

            if (type === 'day') {
                daysThreshold = number
            } else if (type === 'week') {
                daysThreshold = number * 7
            } else if (type === 'year') {
                daysThreshold = number * (leapYear ? 366 : 365)
            }

            if (
                daysDifference <= daysThreshold &&
                daysDifference >= 0 &&
                when === 'from now'
            ) {
                return color ? getColor(color, date) : date
            } else if (
                daysDifference < 0 &&
                Math.abs(daysDifference) >= daysThreshold &&
                when === 'after'
            ) {
                return color ? getColor(color, date) : date
            }
        }

        return date
    } else {
        return getFormattedDate(value)
    }
}